import { defineMessages } from 'react-intl';

export const messages: {
	switchSiteLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	switchSiteLabel: {
		id: 'twg-microsite.siteSwitcher.switchSiteLabel',
		defaultMessage: 'Switch site',
		description: 'Accessible label for the app switcher icon button',
	},
});
